import GeneralService from "./GeneralService";
import { Component } from "react";
import { ExportRequest, FinetuneRequest } from "../model_gen/finetuning";

export class FinetuningService extends Component {
  public static getAvailableData(loadingHandler: any, apiKey: string) {
    return GeneralService.get(
      "/finetuning/data",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static getSessions(
    appId: string,
    intentId: string,
    searchTerm: string, // Add searchTerm parameter
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/finetuning/application/${appId}/intent/${intentId}?search=${encodeURIComponent(
        searchTerm
      )}`, // Include search term in URL
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getAnnotationMetrics(
    appId: string,
    intentId: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/finetuning/application/${appId}/intent/${intentId}/metrics`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getRequests(
    appId: string,
    intentId: string,
    sessionId: string,
    searchTerm: string, // Add searchTerm parameter
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/finetuning/application/${appId}/intent/${intentId}/session/${encodeURIComponent(
        sessionId
      )}?search=${encodeURIComponent(searchTerm)}`, // Include search term in URL
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static updateAnnotation(
    appId: string,
    intentId: string,
    sessionId: string,
    requestId: string,
    label: any,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.put(
      `/finetuning/application/${appId}/intent/${intentId}/session/${encodeURIComponent(
        sessionId
      )}/request/${requestId}`,
      JSON.stringify(label),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static excludeAnnotation(
    appId: string,
    intentId: string,
    sessionId: string,
    requestId: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.put(
      `/finetuning/application/${appId}/intent/${intentId}/session/${encodeURIComponent(
        sessionId
      )}/request/${requestId}/exclude`,
      null,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static exportAnnotations(
    exportRequest: ExportRequest,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      "/finetuning/export",
      JSON.stringify(exportRequest),
      loadingHandler,
      "blob",
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static sendAnnotationEmail(
    companyId: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      `/finetuning/company/${companyId}/send-annotation-email`,
      null,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static finetuneAnnotations(
    exportRequest: Partial<ExportRequest>,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      "/finetuning/run",
      JSON.stringify(exportRequest),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static getFinetuneRuns(loadingHandler: any, apiKey: string) {
    return GeneralService.get(
      "/finetuning/runs",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static rerunFinetune(
    runName: string,
    finetuneRequest: Partial<FinetuneRequest>,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      `/finetuning/runs/${runName}/run`,
      JSON.stringify(finetuneRequest),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static getBaseModels(loadingHandler: any, apiKey: string) {
    return GeneralService.get(
      "/finetuning/base-models",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static manualUpload(
    formData: FormData,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      "/finetuning/manual-upload",
      formData,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
      true
    );
  }
  public static getFinetunedModels(loadingHandler: any, apiKey: string) {
    return GeneralService.get(
      "/finetuning/models",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static updateFinetuneStatus(
    runId: string,
    status: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.put(
      `/finetuning/${runId}/status`,
      JSON.stringify({ status }),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
